export default __webpack_public_path__ + "static/media/fish.15e05d4c.jpg";